<template>
    <el-autocomplete
        v-model="innerValue"
        icon="circle-close"
        :on-icon-click="clearKeyword"
        :disabled="disabled"
        style="width: 100%;"
        value-key="spuName"
        :fetch-suggestions="searchSpuNameByKeyword"
        placeholder="请填写商品名称（SPU）"
        v-bind="$attrs"
        @select="handleSelect"
        @blur="handleBlur"
    />
</template>

<script>
export default {
    name: 'SpuSearchInput',
    props: {
        value: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        supplierId: {
            type: Number,
            default: 0,
        },
        brandId: {
            type: [Number, String],
            default: '',
        },
        bgCategoryId: {
            type: [Number, String],
            default: '',
        },
        categoryId: {
            type: [Number, String],
            default: '',
        },
    },
    data() {
        return {
            innerValue: this.value,
            timeout: null,
        };
    },
    computed: {
        innerSupplierId() {
            return this.supplierId;
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
            this.$emit('input', newVal);
        },
        innerValue(newVal) {
            this.$emit('input', newVal);
        },
    },
    created() {},
    methods: {
        searchSpuNameByKeyword(keyword, cb) {
            clearTimeout(this.timeout);
            if (
                this.innerSupplierId && keyword !== undefined && keyword !== '' && keyword.length <= 30
            ) {
                this.timeout = setTimeout(() => {
                    this.fetchList(keyword, cb);
                }, 800);
            } else {
                cb([]);
            }
        },
        handleSelect(item) {
            this.$emit('select-item', item);
        },
        fetchList(keyword, cb) {
            return this.$service
                .getNewSkuBaseList({
                    spuNameLike: keyword,
                    supplierId: this.innerSupplierId,
                    brandId: this.brandId,
                    bgCategoryList: this.bgCategoryId,
                    categoryList: this.categoryId,
                    paging: {
                        offset: 0,
                        limit: 200,
                    },
                })
                .then((data) => {
                    const spuList = data.items || [];
                    // 根据spuId去重
                    cb(window._.uniqBy(spuList, 'spuId'));
                })
                .catch((err) => {
                    this.$message.error(err.msg || err.message || '获取商品名称列表失败');
                    return [];
                });
        },
        clearKeyword() {
            this.innerValue = '';
        },
        handleBlur(e) {
            this.$emit('blur', e.target.value);
        },
    },
};
</script>
